import { render, staticRenderFns } from "./GreenDeal.vue?vue&type=template&id=23815c00&scoped=true"
import script from "./GreenDeal.vue?vue&type=script&lang=js"
export * from "./GreenDeal.vue?vue&type=script&lang=js"
import style0 from "./GreenDeal.vue?vue&type=style&index=0&id=23815c00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23815c00",
  null
  
)

export default component.exports